<div class="quiz-question">
  <h3 class="quiz-question-text" #questionText tabindex="-1"
    [innerHTML]="getQuestionHtml(question.questionText)">
  </h3>

  <div class="quiz-question-choices" role="radiogroup" [attr.aria-label]="stripHtml(question.questionText)">
    @for (choice of question.answers; track choice; let i = $index) {
      <ut-academy-quiz-choice
        [letter]="getLetterForIndex(i)"
        [text]="choice.answer"
        [choiceId]="choice.id"
        [selected]="isChoiceSelected(choice)"
        (choiceSelected)="onChoiceSelected($event)"
      ></ut-academy-quiz-choice>
    }
  </div>
</div>
